import type PriceRecommendationRoomState from '@app/model/market_state/PriceRecommendationRoomState';
import { recommendationTableRooms } from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/recommmendation/overlay/PriceRecommendationDrawerContents.utilities';

// The information card of the Rec Price cell: which recommendations a card shows, and the anchor that
// carries the request from the "i" button to the one shared card of the table.

export const INFO_CARD_TOOLTIP_ID = 'recommendation-info-card';

// 'date' = the date row (every valid room type of the date); else one room mapping type.
export type InfoCardScope = 'date' | string;

export type InfoCardAnchor = { statDate: string, scope: InfoCardScope };

export const infoCardAnchor = (statDate: string, scope: InfoCardScope): string => `${statDate}|${scope}`;

export const parseInfoCardAnchor = (content: string | null | undefined): InfoCardAnchor | undefined => {
	const [statDate, scope] = (content ?? '').split('|');
	if (statDate === undefined || statDate === '' || scope === undefined || scope === '') return undefined;
	return { statDate, scope };
};

type InfoCardState = {
	roomMappingType: string,
	isValid: boolean,
	minimumBasePriceRoomStates: readonly PriceRecommendationRoomState[],
};

// The date row shows every valid room type of the date; a room-type row shows its type only.
export const selectInfoCardStates = <State extends InfoCardState>(states: readonly State[], scope: InfoCardScope): State[] =>
	states.filter(state => state.isValid && (scope === 'date' || state.roomMappingType === scope));

// The rooms of the card: one row per room, as the drawer table shows them.
export const infoCardRoomCount = (states: readonly InfoCardState[]): number =>
	states.reduce((count, state) => count + recommendationTableRooms(state.minimumBasePriceRoomStates).length, 0);

export const percentChange = (basePrice: number, finalPrice: number): number =>
	basePrice === 0 ? 0 : Math.round(((finalPrice - basePrice) / basePrice) * 100);

// The tabs of a card with two or more room types: 'all' stacks every type; a type shows that type only.
export const INFO_CARD_TAB_ALL = 'all';

export const selectInfoCardTabStates = <State extends { roomMappingType: string }>(states: readonly State[], tab: string): State[] =>
	tab === INFO_CARD_TAB_ALL ? [...states] : states.filter(state => state.roomMappingType === tab);
